var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3084",
    "data-name": "Rectangle 3084",
    width: 24,
    height: 24,
    transform: "translate(-0.24)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clockIcon",
    transform: "translate(0.24)",
    opacity: 0.5,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M27,7.759,21.515,3.2,19.964,5.035l5.489,4.559ZM10.121,4.976,8.569,3.14,3.14,7.759,4.691,9.595l5.43-4.618Zm5.549,5.448H13.879V17.53l5.668,3.376.9-1.481-4.773-2.783V10.424Zm-.6-4.737A10.659,10.659,0,1,0,25.811,16.345,10.692,10.692,0,0,0,15.072,5.686Zm0,18.949a8.291,8.291,0,1,1,8.353-8.291A8.346,8.346,0,0,1,15.072,24.636Z",
    transform: "translate(-3.709 -3.14)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.9b304d405ca692b31025f87fb66f72a7.svg";
export { ForwardRef as ReactComponent };